import { Stack } from '@mui/material';

import { isDefined } from 'common';

import { NodeNameAndHandle } from './Handles/NamedHandle';
import { type ReactFlowBlockNodeProps, type ReactFlowPlaceholderNodeProps } from './types';
import {
  EdgeHandleType,
  ReactFlowErrorEdgeHandleName,
  isPartialBaseBlockNodeWithData,
} from '../../../../types';
import { useReactFlowViewContext } from '../../../context/context';
import { type NodeHandleProps } from '../../types';

interface NodeBodyProps {
  nodeProps: ReactFlowBlockNodeProps | ReactFlowPlaceholderNodeProps;
  nodeHandles: NodeHandleProps[];
}

export function NodeBody(props: NodeBodyProps) {
  const { nodeHandles, nodeProps } = props;
  const {
    data: { areExtraTargetHandlesVisible },
  } = nodeProps;
  const namedOutputHandles = nodeHandles.filter(
    (handle) => isDefined(handle.id) && handle.type === 'source'
  );
  const { edges, isEditable, reactFlowMutators } = useReactFlowViewContext();
  if (namedOutputHandles.length === 0 && !areExtraTargetHandlesVisible) {
    return null;
  }

  return (
    <Stack gap={1} position="relative">
      {namedOutputHandles.map((handle) => {
        return (
          <NodeNameAndHandle
            key={`${handle.type}-${handle.id}`}
            nodeProps={nodeProps}
            nodeHandle={handle}
          />
        );
      })}
      {areExtraTargetHandlesVisible && (
        <NodeNameAndHandle
          nodeProps={nodeProps}
          nodeHandle={{
            id: ReactFlowErrorEdgeHandleName,
            type: 'source',
          }}
          onClose={
            isEditable && isDefined(reactFlowMutators)
              ? () => {
                  const affectedEdgeIds = edges
                    .filter(
                      (edge) =>
                        edge.edgeHandleType === EdgeHandleType.Error && edge.source === nodeProps.id
                    )
                    .map((edge) => edge.id);
                  reactFlowMutators.deleteEdges(affectedEdgeIds);
                  reactFlowMutators.updateNodeData(nodeProps.id, (node) => {
                    if (isPartialBaseBlockNodeWithData(node)) {
                      return {
                        ...node.data,
                        areExtraTargetHandlesVisible: !node.data.areExtraTargetHandlesVisible,
                      };
                    }
                    throw new Error(
                      'Only Block and Placeholder nodes can have extra target handles'
                    );
                  });
                }
              : undefined
          }
        />
      )}
    </Stack>
  );
}
